import React from "react";
import { injectIntl } from "react-intl";
import { SocialIcons } from "./menu/MenuIcons";

function SocialLinks(props) {
  return (
    <div className={"icons-container"}>
      <a href={props.intl.formatMessage({ id: "link_linkedin" })}>
        <SocialIcons {...props} icon={"linkedin"} className={"social-icon"} />
      </a>
      <a href={props.intl.formatMessage({ id: "link_youtube" })}>
        <SocialIcons {...props} icon={"youtube"} className={"social-icon"} />
      </a>
      {/* <a href={props.intl.formatMessage({id: 'link_medium'})}>
            <SocialIcons {...props} icon={'medium'} className={"social-icon"}/>
        </a> */}
    </div>
  );
}

export default injectIntl(SocialLinks);
